import { configureStore } from '@reduxjs/toolkit';
import { setConfig } from 'use-redux-states';
import reducers from './reducers';
import createSagaMiddleware from 'redux-saga';
import storage from 'redux-persist/lib/storage';
import hardSet from 'redux-persist/es/stateReconciler/hardSet';
import persistReducer from 'redux-persist/es/persistReducer';
import persistStore from 'redux-persist/es/persistStore';
import sagas from './sagas';

const sagaMiddleware = createSagaMiddleware();

const persistConfig = {
  key: 'root',
  storage,
  stateReconciler: hardSet,
  blacklist: ['app', 'call' ]
};

const reducer = persistReducer(persistConfig, reducers);

const store = configureStore({
  reducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({ serializableCheck: false }).concat(sagaMiddleware)
});

setConfig({ cleanup: false });

sagaMiddleware.run(sagas);

export const persistor = persistStore(store);

export default store;
